/**
 * Stripe Provider Component
 * Wraps the app with Stripe instance for later use
 * Note: Elements with clientSecret are created in StripePaymentElement
 */

import { loadStripe } from '@stripe/stripe-js';
import type { ReactNode } from 'react';

// Load Stripe instance
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_CLIENT_KEY || 'pk_test_your_key_here');

interface StripeProviderProps {
  children: ReactNode;
}

export function StripeProvider({ children }: StripeProviderProps) {
  // We only load the Stripe instance here, not Elements
  // Elements with clientSecret will be created in StripePaymentElement
  // This is because clientSecret is fetched asynchronously
  return <>{children}</>;
}

export { stripePromise };

export default StripeProvider;
